export default "__VITE_ASSET__2d61d1d1__"